import BlogDetailsSection1 from './BlogDetailsSection1' ;
import BlogDetailsBanner1 from './BlogDetailsBanner1' ;

function BlogDetails1() {
  return (
    <div>
      <BlogDetailsBanner1 />
      <BlogDetailsSection1 />
    </div>
  );
}

export default BlogDetails1;